angular.module('env.data.requestCoupler.requestCouplerUtils', [])

    .service('requestCouplerUtils', function ($http) {

        _.extend(this, {
            createSimpleGetCollectionCoupler: createSimpleGetCollectionCoupler,
            createCustomFieldsCollectionCoupler: createCustomFieldsCollectionCoupler
        });

        /**
         * Create coupler for simple case of collection
         * @param {string} escapedSingleUrl url(escaped for regexp) of single model route
         * @param {string} collectionUrl full url of collection route
         * @returns {{check: Function, process: Function}}
         */
        function createSimpleGetCollectionCoupler(escapedSingleUrl, collectionUrl) {
            var tester = new RegExp("^.*" + escapedSingleUrl + "\/(\\d+)$", "i");

            return createRegExpCollectionCoupler(tester, collectionUrl);
        }

        function createCustomFieldsCollectionCoupler(modelRoute, customFieldRoute, collectionUrl) {
            var tester = new RegExp("^.*" + modelRoute + "\/(\\d+)\/" + customFieldRoute + "\/?$", "i");

            return createRegExpCollectionCoupler(tester, collectionUrl, function (idToCustomField) {
                return idToCustomField ? idToCustomField.customFields : null;
            });
        }

        function createRegExpCollectionCoupler(regexp, collectionUrl, modelProcessor) {
            return {
                check: function (request) {
                    return request.method.toUpperCase() == "GET" && regexp.test(request.url);
                },
                process: function (requests) {
                    var ids = [];
                    for (var i = 0; i < requests.length; i++) {
                        ids.push(regexp.exec(requests[i].url)[1]);
                    }
                    $http.get(collectionUrl, {params: {ids: _.uniq(ids)}})
                        .then(function (resp) {
                            var models = resp.data;
                            var headers = convertHeadersToString(resp.headers);
                            if (models && models.length > 0) {
                                for (var i = 0; i < requests.length; i++) {
                                    var request = requests[i];
                                    var model = _.find(models, function (m) {
                                        return m.id == ids[i];
                                    });
                                    if (model) {
                                        request.callback(resp.status, modelProcessor
                                            ? modelProcessor(model)
                                            : model, headers, resp.statusText);
                                    } else {
                                        request.callback(404, null, headers, "Not found");
                                    }
                                }
                            } else {
                                for (var j = 0; j < requests.length; j++) {
                                    requests[j].callback(404, null, headers, "Not found");
                                }
                            }
                        }, function (resp) {
                            var headers = convertHeadersToString(resp.headers);
                            for (var j = 0; j < requests.length; j++) {
                                requests[j].callback(resp.status, resp.data, headers, resp.statusText);
                            }
                        });
                }
            };
        }

        function convertHeadersToString(headers) {
            var result = '';
            for (var property in headers) {
                result += property + ': ' + headers[property] + '\n';
            }
            return result;
        }

    })

;